
import { useEffect, useState } from "react";
import ProducerBubble from "../Components/ProducerBubble";
import "./ProducersPage.css";
import { getProducers } from "../services/producerService";



export default function ProducersPage() {
  const [producers, setProducers] = useState([]);

  const fetchProducers = async () => {
    try {
      const response = await getProducers();
      setProducers(response);
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    fetchProducers();
  }, [])

  return (
    <div className="relative min-h-screen w-full overflow-hidden bg-zinc-950 text-white">
      <div
        className="pointer-events-none absolute inset-0 opacity-70"
        aria-hidden="true"
        style={{
          background:
            "radial-gradient(circle at 16% 18%, rgba(253, 191, 4, 0.20), transparent 34%), radial-gradient(circle at 84% 14%, rgba(234, 179, 8, 0.14), transparent 28%), radial-gradient(circle at 55% 85%, rgba(250, 204, 21, 0.08), transparent 36%)",
        }}
      />

      <div className="absolute inset-0 animated-spectrum pointer-events-none"></div>

      <div className="relative z-10 flex flex-col items-center px-6 py-16">
        <h1
          className="
            mb-3 text-center text-4xl font-bold md:text-5xl
            drop-shadow-[0_0_15px_rgba(253,191,4,0.5)]
            "
        >
          Productoras Registradas
        </h1>
        <p className="mb-10 text-center text-zinc-300">
          Descubrí las productoras que publican eventos en CatPass.
        </p>

        <div className="relative z-10 w-full max-w-6xl rounded-3xl border border-zinc-800/80 bg-zinc-900/40 px-4 py-8 backdrop-blur-sm sm:px-6">
          <div className="grid grid-cols-2 justify-items-center gap-6 sm:gap-8 md:grid-cols-3 lg:grid-cols-4">
            {producers.map((producer, index) => (
              <div
                key={index + 'index'}
                className={`
              transition-transform duration-300
              ${index % 2 === 0 ? "lg:-translate-y-4" : "lg:translate-y-4"}
              `}
              >
                <ProducerBubble producer={producer} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
